import { API_ERROR_EVENT } from "@services/api/apiError";
import { SnackbarKey, useSnackbar } from "notistack";
import { useEffect, useRef } from "react";

const ApiErrorNotifier = () => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  const lastMessageRef = useRef<{ message: string; at: number }>({
    message: "",
    at: 0,
  });

  useEffect(() => {
    const handleApiError = (event: Event) => {
      const message = (event as CustomEvent<{ message?: string }>).detail
        ?.message;
      if (!message) return;

      const now = Date.now();
      if (
        lastMessageRef.current.message === message &&
        now - lastMessageRef.current.at < 2000
      ) {
        return;
      }
      lastMessageRef.current = { message, at: now };

      enqueueSnackbar(message, {
        variant: "error",
        autoHideDuration: 2000,
        style: {
          backgroundColor: "#FFE8E8",
          color: "#15182C",
        },
        action: (key: SnackbarKey) => (
          <span
            className="material-symbols-outlined text-[16px] text-text-base cursor-pointer"
            onClick={() => closeSnackbar(key)}
          >
            close
          </span>
        ),
      });
    };

    window.addEventListener(API_ERROR_EVENT, handleApiError);
    return () => window.removeEventListener(API_ERROR_EVENT, handleApiError);
  }, [closeSnackbar, enqueueSnackbar]);

  return null;
};

export default ApiErrorNotifier;

